import Chip from '@mui/material/Chip'

import useStyles from './List.style'

export default function List({
    value = [],
}: Readonly<{
    value: string[]
}>) {
    const {
        classes,
    } = useStyles()

    if (!value.length) {
        return null
    }

    return (
        <div className={classes.wrapper}>
            {value?.map((item, index) => {
                return (
                    <Chip
                        className={classes.chip}
                        key={`${item}-item-${index}`} /* eslint-disable-line react/no-array-index-key */
                        label={item}
                        sx={{
                            height: 22,
                            fontSize: 12,
                        }}
                    />
                )
            })}
        </div>
    )
}
